/**
 * Dengteli — floating quote widget behaviour.
 * Loaded with defer from layout/theme.liquid and layout/dengteli-home.liquid.
 *
 * Delivery stays Shopify's built-in {% form 'contact' %}: with JS unavailable the
 * form is a normal POST to /contact. With JS the submit is sent by fetch so the
 * visitor stays where they are, and the outcome is read back from our own
 * server-rendered marker (data-dtq-status) rather than a cosmetic Shopify string.
 * An inconclusive result never silently "succeeds" and never auto-resubmits, so a
 * duplicate enquiry cannot be created by this script.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-dtq-root]');
  if (!root) return;

  var form = root.closest('form') || document.getElementById('dtq-quote-form');
  var bubble = root.querySelector('.dtq-bubble');
  var panel = root.querySelector('.dtq-panel');
  var closeBtn = root.querySelector('.dtq-close');
  var sendBtn = root.querySelector('.dtq-send');
  var errorBox = root.querySelector('.dtq-alert');
  var errorList = root.querySelector('.dtq-alert ul');
  var doneBox = root.querySelector('.dtq-done');
  var live = root.querySelector('.dtq-live');

  if (!form || !bubble || !panel || !sendBtn) return;

  var PENDING_KEY = 'dtq_pending';
  var state = 'idle';

  function flag(value) {
    try {
      if (value === undefined) return sessionStorage.getItem(PENDING_KEY);
      if (value === null) sessionStorage.removeItem(PENDING_KEY);
      else sessionStorage.setItem(PENDING_KEY, value);
    } catch (err) {
      return null;
    }
    return null;
  }

  function announce(message) {
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () {
      live.textContent = message;
    }, 60);
  }

  function setState(next) {
    state = next;
    root.setAttribute('data-dtq-state', next);
    sendBtn.disabled = next === 'sending';
  }

  function focusables() {
    return panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
  }

  function openPanel() {
    if (!panel.hidden) return;
    panel.hidden = false;
    bubble.setAttribute('aria-expanded', 'true');
    if (state === 'sent' && doneBox && typeof doneBox.focus === 'function') {
      doneBox.focus();
    } else {
      panel.focus();
    }
  }

  function closePanel(returnFocus) {
    if (panel.hidden) return;
    panel.hidden = true;
    bubble.setAttribute('aria-expanded', 'false');
    if (returnFocus !== false) bubble.focus();
  }

  bubble.addEventListener('click', function () {
    if (panel.hidden) openPanel();
    else closePanel(true);
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closePanel(true);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    if (panel.hidden) return;
    event.preventDefault();
    closePanel(true);
  });

  function listFromDoc(doc) {
    var nodes = doc.querySelectorAll('[data-dtq-error]');
    var out = [];
    for (var i = 0; i < nodes.length; i += 1) {
      var text = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (text) out.push(text);
    }
    return out;
  }

  function showErrors(messages) {
    setState('error');
    if (errorList && messages && messages.length) {
      errorList.innerHTML = '';
      for (var i = 0; i < messages.length; i += 1) {
        var li = document.createElement('li');
        li.setAttribute('data-dtq-error', '');
        li.textContent = messages[i];
        errorList.appendChild(li);
      }
    }
    announce('Your message could not be sent. Please check the fields and try again.');
    if (errorBox && typeof errorBox.focus === 'function') errorBox.focus();
  }

  function showSent() {
    setState('sent');
    announce('Message sent. Thank you, we will reply within 24 business hours.');
  }

  function showUnknown() {
    setState('unknown');
    announce('We could not confirm your message was sent. Please email daisy@dengteli.com or press Send again.');
  }

  function hasFetch() {
    return typeof window.fetch === 'function' &&
      typeof window.FormData === 'function' &&
      typeof window.DOMParser === 'function';
  }

  form.addEventListener('submit', function (event) {
    if (!hasFetch()) return; // no JS path: let the standard contact POST through
    if (state === 'sending' || state === 'sent') {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    setState('sending');
    flag('1');

    var action = (form.getAttribute('action') || '/contact').split('#')[0];
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 20000);

    var options = {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    };
    if (controller) options.signal = controller.signal;

    window.fetch(action, options)
      .then(function (response) {
        return response.text().then(function (html) {
          return { ok: response.ok, url: response.url || '', html: html };
        });
      })
      .then(function (result) {
        window.clearTimeout(timer);
        var doc = new window.DOMParser().parseFromString(result.html, 'text/html');
        var marker = doc.querySelector('[data-dtq-status]');
        var status = marker ? marker.getAttribute('data-dtq-status') : null;

        if (status === 'error') {
          showErrors(listFromDoc(doc));
          return;
        }
        if (status === 'sent' || result.url.indexOf('contact_posted=true') !== -1) {
          flag(null);
          showSent();
          return;
        }
        showUnknown();
      })
      .catch(function () {
        window.clearTimeout(timer);
        showUnknown();
      });
  });

  // Server-side outcome recovery: only trusted when this widget initiated the
  // submit in this tab, so another page's contact form cannot open this panel.
  var pending = flag() === '1';
  var posted = root.getAttribute('data-dtq-posted') === '1';
  var failed = root.getAttribute('data-dtq-failed') === '1';

  if (pending && (posted || failed)) {
    flag(null);
    if (posted) {
      showSent();
    } else {
      setState('error');
      announce('Your message could not be sent. Please check the fields and try again.');
    }
    openPanel();
  } else {
    setState('idle');
  }
})();
